<template>
    <div class="page-wrapper">
        <div class="clearfix"> </div>
        <div class="page-container">
            <slot name="content"></slot>
        </div>
        <slot name="footer"></slot>
    </div>
</template>
<script>
export default {
}
</script>
